export class QueryValue {
    value: string;
    displayValue: string;
    isFilterIndividual: boolean = true;
}